module.exports = __webpack_public_path__ + "assets/img/yl_product_w.f717cfa0.png";